import { useEffect, useState } from "react";

function useElementHeight<T extends HTMLElement>(): [
  (node: T | null) => void,
  number
] {
  const [element, setElement] = useState<T | null>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (!element) {
      setHeight(0);
      return;
    }

    const measure = (): void =>
      setHeight(element.getBoundingClientRect().height);

    measure();

    const resizeObserver = new ResizeObserver(measure);
    resizeObserver.observe(element);

    return () => resizeObserver.disconnect();
  }, [element]);

  return [setElement, height];
}

export { useElementHeight };
